import { l as e } from "./index.es7.js";
import m from "./index.es34.js";
import p from "./index.es35.js";
import l from "./index.es36.js";
import t from "./index.es37.js";
const E = {
  [e.ElementType.Text]: m,
  [e.ElementType.Tag]: p,
  [e.ElementType.Style]: l,
  [e.ElementType.Directive]: t,
  [e.ElementType.Comment]: t,
  [e.ElementType.Script]: t,
  [e.ElementType.CDATA]: t,
  [e.ElementType.Doctype]: t
};
export {
  E as default
};
//# sourceMappingURL=index.es6.js.map
